// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1pbQ3","title":"Info_title__6S10Y","selects":"Info_selects__2YUPf","requiredAsterisk":"Info_requiredAsterisk__34gk0"};